import { Box, useTheme } from "@mui/material";
import Text from "../../../../../components/theme/text/Text";
import { tokens } from "../../../../../theme";
import AddIcon from '@mui/icons-material/Add';

import { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShLabel from "../../../../../components/theme/label/ShLabel";
import ShLabelSkeleton from "../../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useAddCountingStrategyMutation, useGetCountingStrategiesQuery } from "../../../../../newapi/countingstrategy/countingStrategySlice";
import { general_states } from "../../../../../utils/staticEnums";

import { CheckCircleOutlined } from "@mui/icons-material";
import { WarehouseCountingStrategiesCard } from "../../../../../components/global/cards/other/CountingStrategiesCard";
import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import { getCountingStategyLabelData } from "../../../../../utils/labelColorText";
import Shbutton from "../../../../../components/theme/buttons/Shbutton";
import { selectUserPermission } from "../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../utils/permissions';
import { useSelector } from "react-redux";
import MDynamicValues from "../../../../../components/global/Modals/MDynamicValues";
import ShDateWithMonthShortcuts from "../../../../../components/theme/ShDateWithMonthShortcuts";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../../utils/toasts";
import { useGetRelationsSelectQuery } from "../../../../../newapi/global/relation/relationSlice";
import { useGetWarehouseLocationTypesSelectQuery } from "../../../../../newapi/warehouse/warehouseLocationTypeSlice";
import { useGetWarehousesSelectQuery, useGetWarehouseZonesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import { useGetWarehouseLocationSelectQuery } from "../../../../../newapi/warehouse/warehouselocationSlice";
import { ShDropdownSearchQuery } from "../../../../../components/theme/dropdowns/Dropdown";
import { InputDropdownContent } from "../../../../../components/theme/dropdowns/InputDropdown";
import SHQuickAction from "../../../../../components/theme/Modal/SHQuickAction";
const SpCountingStrategyDetails = SidepanelLoader(() => import("../../../../../components/global/Sidepanels/SpCountingStrategyDetails/SpCountingStrategyDetails"));

const GridActions = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1} gap={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                onClick={() => props.handleOpen(true)}
                endIcon={<AddIcon/>}
                variant="contained"
            >
                {t("new_counting_strategy")}
            </Shbutton>
            )}
        </Box>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const All = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.COUNTINGSTRATEGY_MANAGE])
    );
    const selectedActiveWarehouseId = useSelector(state => state.warehouse.activeId);
    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
        
    const { data: relationData, relationIsLoading } = useGetRelationsSelectQuery();
    const { data: warehouseLocationTypeData, warehouseLocationTypeIsLoading } = useGetWarehouseLocationTypesSelectQuery();
    const { data: warehouseZoneData, warehouseZoneIsLoading } = useGetWarehouseZonesSelectQuery();
    const { data: warehouseData, warehouseIsLoading } = useGetWarehousesSelectQuery();

    const [warehouseZoneOptions, setWarehouseZoneOptions] = useState([]);
    const [warehouseLocationTypeOptions, setWarehouseLocationTypeOptions] = useState([]);
    const [warehouseOptions, setWarehouseOptions] = useState([]);

    useEffect(() => {
        if (warehouseZoneData) {
            setWarehouseZoneOptions(warehouseZoneData.data.map(x => {
                return {
                    id: x.id,
                    name: `${x.description} (${x.warehouse?.name})`,
                    warehouseId: x.warehouse?.id
                }
            }));
        }
    }, [warehouseZoneData]);

    useEffect(() => {
        if (warehouseLocationTypeData) {
            setWarehouseLocationTypeOptions(warehouseLocationTypeData.data.map(x => {
                return {
                    id: x.id,
                    name: x.description
                }
            }));
        }
    }, [warehouseLocationTypeData]);

    useEffect(() => {
        if (warehouseData) {
            setWarehouseOptions(warehouseData.data);
        }
    }, [warehouseData]);

    const ref = useRef();
    const [config, setConfig] = useState({"state": general_states.ACTIVE});

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>,
        });

        return () => {
        }
    },[]);
    // pickingJobListId
    
    const handleOpen = () => {
        setAddModalOpen(true);
    }

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }
    
    const [createCountingStrategy,{isLoading}] = useAddCountingStrategyMutation();

    const saveCountingStrategy = async (values) => {
        try {
            if (isLoading) return;
            const data = await createCountingStrategy({
                ...values,
                warehouseLocations: (values.warehouseLocations ?? []).map(x => x.id)
            }).unwrap()
            showToastMessagePostRequest(t, data);
        } catch (err) {
            showToastMessageRequestError(t("create_failed"), t, err);
        }
    };

    const [strategyId, setStrategyId] = useState();
    const strategyIdRef = useRef(strategyId);
    
    const getCountingStrategy = (params) => {
        if (!params) return;
    
        const newStrategyId = parseInt(params.row.id);
        // Only update state if the pickingJobListId has actually changed
        if (strategyIdRef.current !== newStrategyId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setStrategyId(newStrategyId);
            strategyIdRef.current = newStrategyId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {
            field: "createdAt",
            headerName: t("created_on"),
            flex:1,
            shFilter : {
                type: "date",
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.createdAt);
              
                return (
                    <Text>
                        {date.toLocaleString(i18n.language)}
                    </Text>
                );
            }
        },
        {
            field: "name", 
            headerName: t("name"),
            flex:1,
            renderCell: (params) => {
                //TODO: brownie, implement
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                
                return params.row.name;
              }
        },
        {
            field: "type", 
            headerName: t("type"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                const {labeltext, labelcolor} = getCountingStategyLabelData(params.row.type,theme);
                

                return (
                    <ShLabel 
                        clickable
                        variant={labelcolor}
                        fitted
                        size={32} 
                        palette="normal" 
                    >
                        {t(labeltext)}
                    </ShLabel>
                );
            }
        },
        // {
        //     field: "frequency", 
        //     headerName: t("frequency"),
        //     flex:1,
        //     renderCell: (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }

        //         return t(params.row.frequency);
        //     }
        // },
        {
            field: "amountOfSteps", 
            headerName: t("amount_of_objects"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.amountOfSteps;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                let labelColor = params.row.state === "active" ? theme.palette.mode === "dark" ? "blue" : "primary" : "green";
                
                let content;
                if(params.row.state === "active") {
                    content = t(params.row.state);
                } else {
                    if (!params.row.completedAt || params.row.completedAt === null) {
                        content = t(params.row.state);
                    } else {
                        let date = new Date(params.row.completedAt);
                        content = date.toLocaleString(i18n.language);
                    }
                }

                return (
                    <ShLabel
                        clickable
                        sx={{
                            ...(params.row.state !== 'active' && content.indexOf("-") > -1 && {
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center",
                                pr:0,
                            }),
                        }}
                        size={32} 
                        palette="normal" 
                        variant={labelColor}
                    >
                        <Text bold sx={{ml:"auto"}} color={labelColor} center>
                            {content}
                        </Text>
                        {params.row.state !== "active" && content.indexOf("-") > -1 &&
                            <Box
                                sx={{
                                    color:colors['green'][400],
                                    height:24,
                                    width:24,
                                    // color:"white",
                                    ml:"auto",
                                    mr:0.5,
                                    borderRadius:4
                                }}
                            >
                                <CheckCircleOutlined/>
                            </Box>
                        }
                    </ShLabel>
                  );
              }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <WarehouseCountingStrategiesCard onClick={() => getCountingStrategy(params)} {...params.row} skeleton={params.row.skeleton ?? false}/>
                )
            }
        }
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetCountingStrategiesQuery}
                config={config}
                gridActions={<GridActions handleOpen={handleOpen} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                onRowClick={getCountingStrategy}
                >
            </ShDataGrid2>
            <MDynamicValues
                open={addModal.open}
                handleClose={() => addModal.setOpen(false)}
                title={t("new_counting_strategy")}
                labelWidth={200}
                fields={[
                    ...(isFulfilment ? [{ name: "relationId", label: t("relation"), type: "list", options: relationData, search: true }] : []),
                    ...(isFulfilment ? [{ name: "excludeRelations", label: t("exclude_relations"), type: "list", options: relationData, search: true, multiple: true }] : []),
                    ...(warehouseOptions && warehouseOptions.length > 1 && parseInt(selectedActiveWarehouseId) < 0 ? [{
                        name: "warehouseId",
                        label: t("warehouse"),
                        type: "list",
                        options: warehouseOptions,
                        defaultValue: warehouseOptions.length === 1
                            ? warehouseOptions[0].id
                            : (selectedActiveWarehouseId !== -1 ? selectedActiveWarehouseId : undefined)
                    }] : []),
                    {
                        name: "warehouseZones",
                        label: t("warehouseZones"),
                        type: "list",
                        options: warehouseZoneOptions,
                        search: true,
                        multiple: true,
                        optionsFilter: (option, formValues) => {
                            // If no warehouse selected, show all zones
                            if (!formValues.warehouseId) return true;
                            // Filter zones by selected warehouse
                            return option.warehouseId === formValues.warehouseId;
                        }
                    },
                    { name: "warehouseLocationTypes", label: t("warehouse_location_types"), type: "list", options: warehouseLocationTypeOptions, search: true, multiple: true },
                    {
                        // Keeps id and name of every picked location, so the names stay visible after a new search
                        name: "warehouseLocations",
                        label: t("locations"),
                        type: "custom",
                        render: ({ value, onChange }) => {
                            const selectedLocations = value ?? [];
                            return (
                                <ShDropdownSearchQuery
                                    content={useGetWarehouseLocationSelectQuery}
                                    displayName={"name"}
                                    multiple
                                    selected={selectedLocations.map(x => x.id)}
                                    searchOptions={{
                                        placeholder: t("search")
                                    }}
                                    maxHeight={270}
                                    onChange={(selected, option) => {
                                        if (selectedLocations.some(x => x.id === option.id)) {
                                            onChange(selectedLocations.filter(x => x.id !== option.id));
                                        } else {
                                            onChange([...selectedLocations, { id: option.id, name: option.name }]);
                                        }
                                    }}
                                >
                                    {({ anchorEl, onClick }) => (
                                        // Hovering the field lists every picked location; hidden while searching
                                        <SHQuickAction
                                            interactive
                                            open={selectedLocations.length > 1 && !anchorEl}
                                            disableAutoFocus
                                            disableEnforceFocus
                                            disableRestoreFocus
                                            component={
                                                <Box
                                                    sx={{
                                                        minWidth: 200,
                                                        maxHeight: 240,
                                                        overflow: "auto",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 1,
                                                    }}
                                                >
                                                    {selectedLocations.map(location => (
                                                        <Text key={"cs-loc" + location.id} noBreak>{location.name}</Text>
                                                    ))}
                                                </Box>
                                            }
                                        >
                                            {({ onMouseEnter, onMouseLeave, onTouchStart }) => (
                                                <Box
                                                    onMouseEnter={onMouseEnter}
                                                    onMouseLeave={onMouseLeave}
                                                    onTouchStart={onTouchStart}
                                                    sx={{ width: 1 }}
                                                >
                                                    <InputDropdownContent
                                                        onClick={onClick}
                                                        multiple
                                                        valueKey={"id"}
                                                        displayName={"name"}
                                                        options={selectedLocations}
                                                        selected={selectedLocations.map(x => x.id)}
                                                        noSelection={t("choose_option")}
                                                    />
                                                </Box>
                                            )}
                                        </SHQuickAction>
                                    )}
                                </ShDropdownSearchQuery>
                            );
                        },
                    },
                    { name: "type", label: t("location_type"), type: "list", options: [{id: "picking_locations", name: t("picking_locations")},{id: "bulk_locations", name: t("bulk_locations")},{id: "all_locations", name: t("all")}] },
                    { name: "maxItemQuantity", label: t("max_amount_of_items"), type: "integer", explainerTitle: t("max_amount_of_items"), explainerSubTitle: t("em_max_amount_of_items_text")},
                    { name: "maxAmountOfStock", label: t("max_stock"), type: "integer", explainerTitle: t("max_stock"), explainerSubTitle: t("em_max_stock_text") },
                    {
                        name: "excludeCountedAfter",
                        label: t("exclude_stock_counted_after"),
                        type: "custom",
                        render: ({ value, onChange }) => (
                            <ShDateWithMonthShortcuts value={value} onChange={onChange} />
                        ),
                    },
                ]}
                onConfirm={(values) => saveCountingStrategy(values)}
            />

            {spLoading && 
                <SpCountingStrategyDetails
                    strategyId={strategyId}
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    // data={pickingJobData}
                /> 
            }
        </Box>
    );
}

export default All;